import React from 'react';
import { QuoteIcon } from 'lucide-react';
export const Testimonials = () => {
  return <section className="mb-10" data-id="element-156">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-157">
        Echte Resultaten Van Echte Mensen
      </h2>
      <p className="mb-6 leading-relaxed" data-id="element-158">
        Voordat ik vertel wat je in het webinar gaat leren, wil ik je laten
        horen van mensen die deze transformatie al hebben meegemaakt:
      </p>
      <div className="space-y-6 mb-6" data-id="element-159">
        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-300" data-id="element-160">
          <div className="flex mb-3" data-id="element-161">
            <div className="mr-4 flex-shrink-0" data-id="element-162">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1uENzFyeTcPi87ozEBzC5A/Scherm%C2%ADafbeelding_2025-08-15_om_15.51.14.png" alt="Patricia uit Utrecht met haar hond" className="w-16 h-16 rounded-full object-cover" data-id="element-163" />
            </div>
            <div data-id="element-164">
              <QuoteIcon className="w-6 h-6 text-blue-300 mr-2 flex-shrink-0 float-left" data-id="element-165" />
              <p className="italic" data-id="element-166">
                "Ik had al veel hondentrainingen gevolgd en certificaten
                gehaald, maar toch kreeg mijn hond gedragsproblemen... De
                methode 'Liefdevol communiceren' heeft echt een verschil
                gemaakt. Mijn zelfvertrouwen is gegroeid en ik voel me rustiger.
                De samenwerking is veel prettiger geworden."
              </p>
              <p className="text-right text-sm font-medium mt-2" data-id="element-167">
                - Patricia uit Utrecht
              </p>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-300" data-id="element-168">
          <div className="flex mb-3" data-id="element-169">
            <div className="mr-4 flex-shrink-0" data-id="element-170">
              <img src="https://images.unsplash.com/photo-1529429617124-95b109e86bb8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="Jan uit Antwerpen met zijn hond" className="w-16 h-16 rounded-full object-cover" data-id="element-171" />
            </div>
            <div data-id="element-172">
              <QuoteIcon className="w-6 h-6 text-blue-300 mr-2 flex-shrink-0 float-left" data-id="element-173" />
              <p className="italic" data-id="element-174">
                "De aanpak van liefdevol communiceren met je hond is echt een
                eyeopener en de communicatie lichaamstaal werkt super goed. Mijn
                hond begrijpt het meteen."
              </p>
              <p className="text-right text-sm font-medium mt-2" data-id="element-175">
                - Jan uit Antwerpen
              </p>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-300" data-id="element-176">
          <div className="flex mb-3" data-id="element-177">
            <div className="mr-4 flex-shrink-0" data-id="element-178">
              <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="Linda uit Rotterdam met haar hond" className="w-16 h-16 rounded-full object-cover" data-id="element-179" />
            </div>
            <div data-id="element-180">
              <QuoteIcon className="w-6 h-6 text-blue-300 mr-2 flex-shrink-0 float-left" data-id="element-181" />
              <p className="italic" data-id="element-182">
                "Sinds ik geleerd heb om liefdevol te communiceren, voel ik meer
                connectie met mijn honden en kan ik andere honden beter lezen.
                Ik zie nu hoe een hond zich voelt. We ervaren meer rust in
                huis."
              </p>
              <p className="text-right text-sm font-medium mt-2" data-id="element-183">
                - Linda uit Rotterdam
              </p>
            </div>
          </div>
        </div>
      </div>
      <p className="text-center text-sm mb-8" data-id="element-184">
        Deze verhalen zijn niet uniek. Met meer dan 15.000 geholpen baasjes en
        100.000+ mensen die mijn webinars hebben bekeken, heb ik een{' '}
        <span className="font-bold" data-id="element-185">
          4,3/5 sterren beoordeling op Trustpilot
        </span>{' '}
        met 584+ reviews.
      </p>
    </section>;
};